import React, { useEffect, useState } from "react";
import statsApi from "../../../../api/stats-api";
import { getRequestError } from "../../../../utils/functions";
import moment from "moment";
import useStyles from "../MainDashboard/MainDashboard.styles";
import DateSelector from "../../../../components/Inputs/DateSelector";
import Chart from "../../../../components/Chart";
import generateChart from "../utils/graphs";
import { CSVLink } from "react-csv";
import DownloadIcon from "@material-ui/icons/GetApp";

const RedemptionRate = ({ jwt }) => {
  const [startDate, setStartDate] = useState(
    moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [isLoadingRedemptionRate, setIsLoadingRedemptionRate] = useState(false);
  const [redemptionRate, setRedemptionRate] = useState(null);

  const { filter, filterContainer } = useStyles({
    active: false
  });

  useEffect(() => {
    setIsLoadingRedemptionRate(true);
    statsApi
      .getRedemptionRate(jwt, startDate, endDate)
      .then(res => {
        const chart = generateChart(
          res.data?.data.map(item => [item?.redemptionRate ?? 0]),
          ["Redemption rate"],
          res.data?.data?.map(item => item?.date)
        );
        setRedemptionRate(chart);
        setIsLoadingRedemptionRate(false);
      })
      .catch(e => getRequestError(e));
  }, [endDate, jwt, startDate]);

  return (
    <div>
      <div>
        <Chart
          data={redemptionRate || []}
          type="redemption"
          title="Redemption rate"
          height={80}
          xLabel="Months"
          yLabel="Rate (%)"
          hasFullReport={false}
          loading={isLoadingRedemptionRate}
          filterComponent={
            <div className={filterContainer}>
              <CSVLink
                data={
                  redemptionRate?.labels.map((item, index) => ({
                    date: item,
                    rate: redemptionRate?.datasets[0].data[index]
                  })) ?? []
                }
                filename={"redemption-rate.csv"}
              >
                <button
                  disabled={isLoadingRedemptionRate}
                  className="export-btn"
                >
                  <DownloadIcon color="#A233E2" />
                  EXPORT REPORT
                </button>
              </CSVLink>
              <div className={filter}>
                <DateSelector
                  value={startDate}
                  onChange={e => setStartDate(moment(e).format("YYYY-MM-DD"))}
                />
              </div>
              <div className={filter}>
                <DateSelector
                  value={endDate}
                  onChange={e => setEndDate(moment(e).format("YYYY-MM-DD"))}
                />
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default RedemptionRate;
